import script from "./SecDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SecDataTable.vue?vue&type=script&setup=true&lang=js"

import "./SecDataTable.vue?vue&type=style&index=0&id=af3a6ac6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af3a6ac6"]])

export default __exports__